import { useCallback } from "react";
import {
  EfsMelcoModelsDesignElement,
  ElementListHelper,
  EfsMelcoModelsDesign,
} from "melco-shared-logic";

const { isLettering, isColor, isDesign, isNotActiveGroupColor } =
  ElementListHelper;

export const useDesignElementList = (design: EfsMelcoModelsDesign) => {
  const { element_list: elementList } = design;

  const letteringObjects = (elementList ?? []).filter(
    (e) => isLettering(e) && isNotActiveGroupColor(e)
  );
  const colorObjects = (elementList ?? []).filter(
    (e) => isColor(e) && isNotActiveGroupColor(e)
  );

  const designObjects = (elementList ?? []).filter(
    (e) => isDesign(e) && isNotActiveGroupColor(e)
  );

  const mappableElements = [
    ...letteringObjects,
    ...colorObjects,
    ...designObjects,
  ];

  const groupIndex = useCallback(
    (element: EfsMelcoModelsDesignElement) =>
      (isLettering(element)
        ? letteringObjects
        : isColor(element)
        ? colorObjects
        : designObjects
      ).indexOf(element) + 1,
    [letteringObjects, colorObjects, designObjects]
  );

  return {
    letteringObjects,
    colorObjects,
    designObjects,
    mappableElements,
    groupIndex,
  };
};
